var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightFromLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M265.375 150.625L338.75 224H160C142.312 224 128 238.312 128 256S142.312 288 160 288H338.75L265.375 361.375C259.125 367.625 256 375.812 256 384S259.125 400.375 265.375 406.625C277.875 419.125 298.125 419.125 310.625 406.625L438.625 278.625C451.125 266.125 451.125 245.875 438.625 233.375L310.625 105.375C298.125 92.875 277.875 92.875 265.375 105.375S252.875 138.125 265.375 150.625ZM64 416V96C64 78.312 49.688 64 32 64S0 78.312 0 96V416C0 433.688 14.312 448 32 448S64 433.688 64 416Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightFromLine);
export default __webpack_public_path__ + "static/media/arrow-right-from-line.8c66e1cdb7a55d7e1a42b635f16f9ad7.svg";
export { ForwardRef as ReactComponent };